export enum ApplicationType {
  DEALER = 'DEALER',
  LEASE_BUYOUT = 'LEASE_BUYOUT',
  PERSONAL_SECURED_LOAN = 'PERSONAL_SECURED_LOAN',
  PRIVATE_PARTY = 'PRIVATE_PARTY',
  PURCHASE = 'PURCHASE',
  RE_F_AND_I = 'RE_F_AND_I',
  REFINANCE = 'REFINANCE',
}
